// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"630":"42b7b532","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"630":"ddefba7b362b2663","2450":"72d3e031a7b5b54a","5279":"1c7c4f9c2a6a6503","7229":"12afbd9d454ee54c"}[chunkId] + ".js";
};